import { EmptyState } from '../../shared/ui';
import { PageHeader } from '../AdminShell';

/** Placeholder. The layout is real; the surface is not built yet. */
export default function AdminDiscussions() {
  return (
    <>
      <PageHeader title="Discussions" description="Forum activity and moderation." />
      <EmptyState title="Not built yet" body="Moderation tools will live here." />
    </>
  );
}
